<template>
  <div id="company-progress">
    <div class="row">
      <div class="col-12 title">
        Complete your registration {{ completedSteps }}/4
      </div>
    </div>
    <div class="row task-list mt-4">
      <div
        v-for="(task, index) of tasks"
        :key="index"
        :id="task.id"
        class="col-12"
        @click="task.action"
      >
        <router-link :to="task.url">
          <img
            class="unchecked"
            src="/static/images/icons/unchecked.svg"
            alt=""
          />
          <img class="checked" src="/static/images/icons/checked.svg" alt="" />
          {{ task.name }}
          <font-awesome-icon
            class="arrow-icon"
            :icon="'chevron-right'"
            size="1x"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyProgress',
  props: {
    progress: Object,
  },
  mounted() {
    Object.keys(this.progress).forEach((key) => {
      if (this.progress[key] === true) {
        document.getElementById(key + 'Task').classList.add('completed');
      }
    });
  },
  computed: {
    tasks() {
      return [
        {
          name: 'Set name of your company',
          url: '/team?tab=4',
          action: () => {},
          id: 'companyLevelTask',
        },
        {
          name: 'Give your name',
          url: '/profile',
          action: () => {},
          id: 'userLevelTask',
        },
        {
          name: 'Invite teammates',
          url: '/',
          id: 'teamLevelTask',
          action: () => {
            this.$emit('showInviteModal');
          },
        },
        {
          name: 'Give first feedback',
          url: '/',
          action: () => {
            this.$emit('showFeedbackModal');
          },
          id: 'feedbackLevelTask',
        },
      ];
    },
    completedSteps() {
      return Object.values(this.progress).filter((x) => x).length;
    },
  },
};
</script>

<style lang="scss" scoped>
#company-progress {
  margin-left: 15px;
  text-align: left;
  margin-top: 40px;
  .title {
    font-size: 1.2rem;
    font-weight: bolder;
  }
  .checked,
  .unchecked {
    max-height: 32px;
    margin-right: 10px;
  }
  .task-list {
    .col-12 {
      a {
        padding: 10px;
        font-weight: bold;
        background-color: rgba(233, 233, 248, 0.7);
        border-radius: 8px;
        margin: 5px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &:hover {
          background-color: rgba(233, 233, 248, 0.9);
          cursor: pointer;
          .arrow-icon {
            display: inline;
          }
        }
        .arrow-icon {
          display: none;
          margin-left: auto;
          margin-right: 10px;
        }
      }
    }
    .completed {
      text-decoration: line-through;
      .unchecked {
        display: none;
      }
      .checked {
        display: inline;
      }
    }
    .checked {
      display: none;
    }
  }
}
</style>